import { objectForEach, isEmptyObject, isAbsoluteURL } from 'javascripts/utils';

document.addEventListener('DOMContentLoaded', () => {
  const dataLayer = window.dataLayer || [];
  const data = dataLayer[0] || {};

  const eligibleForSplitTest = data.eligibleForSplitTest;
  const splitTestParams = data.siteWideSplitTestQueryParams || {};

  if (eligibleForSplitTest && !isEmptyObject(splitTestParams)) {
    const elements = document.querySelectorAll('[href], [data-href]');
    const skipValues = ['javascript:;', 'javascript:void(0)', '#'];

    elements.forEach((el) => {
      const attr = el.hasAttribute('data-href') ? 'data-href' : 'href';
      const urlString = el.getAttribute(attr);

      if (skipValues.includes(urlString)) { return; }

      try {
        // Create a URL object, using the current location as the base for relative URLs
        const url = new URL(urlString, window.location.origin);

        objectForEach(splitTestParams, (value, key) => { url.searchParams.set(key, value) });

        // Handle relative URLs by reconstructing the pathname, search, and hash
        const newUrl = isAbsoluteURL(urlString) ? url.toString() : url.pathname + url.search + url.hash;

        el.setAttribute(attr, newUrl);
      } catch (e) {
        console.error('Invalid URL encountered:', urlString, e);
      }
    });
  }
});
